export const videoData = [
	{
		n:1,
		titre : "La pose de bas de contention",
		url: "https://adherents.prevandcare.com/uploads/videos/formation/1.mp4"
	},
	{
		n:2,
		titre : "Utilisation du lève-personne",
		url: "https://adherents.prevandcare.com/uploads/videos/formation/2.mp4"
	},
	{
		n:3,
		titre : "Transfert du lit au fauteuil roulant",
		url: "https://adherents.prevandcare.com/uploads/videos/formation/3.mp4"
	},
	{
		n:4,
		titre : "Aide au levé simple",
		url: "https://adherents.prevandcare.com/uploads/videos/formation/4.mp4"
	},
	{
		n:5,
		titre : "Le shampooing au lit ou Capiluve",
		url: "https://adherents.prevandcare.com/uploads/videos/formation/5.mp4"
	},
	{
		n:6,
		titre : "Conseils nutritionnels",
		url: "https://adherents.prevandcare.com/uploads/videos/formation/6.mp4"
	},
	{
		n:7,
		titre : "Aide au levé du sol",
		url: "https://adherents.prevandcare.com/uploads/videos/formation/7.mp4"
	},
	{
		n:8,
		titre : "Aide à l’habillage en fonction de la pathologie",
		url: "https://adherents.prevandcare.com/uploads/videos/formation/8.mp4"
	},
	{
		n:9,
		titre : "La réfection du lit occupé",
		url: "https://adherents.prevandcare.com/uploads/videos/formation/9.mp4"
	},
	{
		n:10,
		titre : "La fin de vie",
		url: "https://adherents.prevandcare.com/uploads/videos/formation/10.mp4"
	},
	{
		n:11,
		titre : "Le refus d’aide",
		url: "https://adherents.prevandcare.com/uploads/videos/formation/11.mp4"
	},
	{
		n:12,
		titre : "L’aménagement du domicile",
		url: "https://adherents.prevandcare.com/uploads/videos/formation/12.mp4"
	},
];